import React, { useContext, useState } from 'react';
import '../NAV/navigationBar.css';
import logo from '../images/logo.png';
import { DataContext } from '../contextAPI';
const NavigationBar = () => {
	const { toggleMode } = useContext(DataContext);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [clicked, setClicked] = useState('Home');

	const handleItemClick = (itemName) => {
		setClicked(itemName);
		setIsMenuOpen(false);
	};

	return (
		<div>
			<input
				type="checkbox"
				id="navcheck"
				checked={isMenuOpen}
				onChange={() => setIsMenuOpen(!isMenuOpen)}
			/>
			<div className="nav-btn ">
				<label className="navcheck">
					<span></span>
					<span></span>
					<span></span>
				</label>
			</div>

			<header className={`nav-header ${toggleMode ? 'theme' : 'dark-mode'}`}>
				<nav className={`navbar theme ${toggleMode ? 'theme' : 'dark-mode'}`}>
					<img
						className="logo-text"
						src={logo}
						alt="Reham's logo "
						width="200"
						height="50"
					/>

					<ul className={`nav-menu  ${toggleMode ? 'theme' : 'dark-mode'}`}>
						<li className={`${clicked === 'Home' ? 'nav-link' : ''}`}>
							<a
								href="#Home"
								onClick={() => handleItemClick('Home')}
								style={{ color: clicked === 'Home' ? '#BC379E' : '' }}>
								Home
							</a>
						</li>
						<li className={`${clicked === 'About' ? 'nav-link' : ''}`}>
							<a
								href="#About"
								onClick={() => handleItemClick('About')}
								style={{ color: clicked === 'About' ? '#BC379E' : '' }}>
								About
							</a>
						</li>
						<li className={`${clicked === 'Skills' ? 'nav-link' : ''}`}>
							<a
								href="#Skills"
								onClick={() => handleItemClick('Skills')}
								style={{ color: clicked === 'Skills' ? '#BC379E' : '' }}>
								Skills
							</a>
						</li>
						<li className={`${clicked === 'Service' ? 'nav-link' : ''}`}>
							<a
								href="#Services"
								onClick={() => handleItemClick('Service')}
								style={{ color: clicked === 'Service' ? '#BC379E' : '' }}>
								Projects
							</a>
						</li>
						<li className={`${clicked === 'Contact' ? 'nav-link' : ''}`}>
							<a
								href="#Contact"
								onClick={() => handleItemClick('Contact')}
								style={{ color: clicked === 'Contact' ? '#BC379E' : '' }}>
								Contact
							</a>
						</li>
					</ul>
				</nav>
			</header>

			<div class="backdrop"></div>
		</div>
	);
};

export default NavigationBar;
